import { changeProps, insertObjectAfter, insertObjectBefore, removeObject, returnFound } from "find-and";
import { TreeSourcePosition, TreeDestinationPosition } from "@atlaskit/tree";

import { LAYER_TREE_ROOT_ID } from "./layers";

export function reoderList<T>(items: T[], from: number, to: number): T[] {
  const copy = items.slice();

  copy.splice(from, 1);
  copy.splice(to, 0, items[from]);

  return copy;
}

export function reoderTree<T>(items: T[], from: TreeSourcePosition, to: TreeDestinationPosition): T[] {
  if (from.parentId === to.parentId && (from.index === to.index || to.index === undefined)) {
    return items;
  }

  const source = returnFound(items, { name: from.parentId });
  let destination = returnFound(items, { name: to.parentId });

  if (!source?.children && !destination?.children) {
    return reoderList(items, from.index, to.index);
  }

  if (!destination?.children && to.parentId !== LAYER_TREE_ROOT_ID) {
    return items;
  }

  const sourceChild = source?.children?.[from.index];
  const currentSource = sourceChild || source || items[from.index];
  let copy = removeObject(items, { name: currentSource.name });

  if (destination) {
    const currDest = destination.children?.[to.index];
    const prevDest = destination.children?.[to.index - 1];

    if (returnFound(destination, { name: currentSource.name })) {
      destination = removeObject(destination, { name: currentSource.name });
    }

    copy =
      from.parentId === to.parentId && to.index > from.index && currDest
        ? insertObjectAfter(copy, { name: currDest.name }, currentSource)
        : currDest
        ? insertObjectBefore(copy, { name: currDest.name }, currentSource)
        : prevDest
        ? insertObjectAfter(copy, { name: prevDest.name }, currentSource)
        : changeProps(copy, { name: destination.name }, { children: [...(destination.children || []), currentSource] });
  } else {
    copy.splice(to.index, 0, currentSource);
  }

  return copy;
}
